import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Container = ({ hasTwoCol, children, extraClasses }) => {
    const classNames = clsx('pc-container', hasTwoCol && '-two-columns', extraClasses)

    return <div className={classNames}>{children}</div>
}

Container.propTypes = {
    hasTwoCol: PropTypes.bool,
}

Container.defaultProps = {
    hasTwoCol: false,
}

export default Container
